import {Component, OnDestroy} from '@angular/core'
import {OptableLayout} from '../../../../core/components/layout/optable-layout.interface'
import {CalculatorsService} from '../calculators.service'
import {Meta} from '@angular/platform-browser'
import {TranslocoService} from '@ngneat/transloco'
import {PageComponent, PageMetadata} from '../../../../core/seo/page-metadata'
import {Observable} from 'rxjs'
import {map} from 'rxjs/operators'

@Component({
  templateUrl: './erneuerbarheizen-calculator-page.component.html',
})
export class ErneuerbarheizenCalculatorPageComponent extends PageComponent implements OptableLayout, OnDestroy {
  hideNavbar = true
  hideFooter = true
  optOutOfLayout = true

  get logo(): string {
    return `/assets/images/erneuerbarheizen/logo_${this.localeService.getActiveLang()}.svg`
  }

  get partnerLink(): string {
    switch (this.localeService.getActiveLang()) {
      case 'de':
        return 'https://erneuerbarheizen.ch/'
      case 'fr':
        return 'https://www.chauffezrenouvelable.ch/'
      case 'it':
        return 'https://www.calorerinnovabile.ch/'
      default:
        return ''
    }
  }

  constructor(
    readonly calculatorsService: CalculatorsService,
    readonly meta: Meta,
    private readonly localeService: TranslocoService,
  ) {
    super()
    meta.updateTag({name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1'})
  }

  getPageMetadata(): Observable<PageMetadata> {
    return this.localeService.selectTranslate('calculators.erneurbarheizen.pageTitle').pipe(map(title => ({title})))
  }

  ngOnDestroy(): void {
    this.meta.updateTag({name: 'viewport', content: 'width=device-width, initial-scale=1'})
  }
}
